<section class="login">
    <div class="logo">
        <img src="./assets/logo.png" alt="logo">
    </div>
    <div>
        <mat-card>
            <mat-card-content *ngIf="isShowMsg">
                <div class="row">
                    <div class="col-lg-12">
                        <form [formGroup]="changePasswordForm" (ngSubmit)="changePasswordFormSubmit()" autocomplete="off">
                            <div class="row">
                                <div class="col-lg-12">
                                    <mat-form-field>
                                        <mat-label>New Password</mat-label>
                                        <input type="password" matInput formControlName="new_password" autocomplete="off" />
                                        <mat-error *ngIf="changePasswordFormValidate?.new_password?.errors?.required">This field is required.</mat-error>
                                        <mat-error *ngIf="changePasswordFormValidate?.new_password?.errors?.minlength"> Password must be at least 8 characters long.</mat-error>

                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <mat-form-field>
                                        <mat-label>Confirm New Password</mat-label>
                                        <input type="password" matInput formControlName="confirm_new_password" autocomplete="off" />
                                        <mat-error *ngIf="changePasswordFormValidate?.confirm_new_password?.errors?.mustMatch">Passwords must match.</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <button type="submit" class="btn-int-blue" mat-raised-button color="primary">Save</button><br>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- <div class="col-lg-offset-1 col-lg-5">
                        <p class="font-bold"> Your Password must </p>
                        <p> Be at least <b>8</b> characters long</p>
                        <p> Have at least one upper case letter</p>
                        <p> Have at least one lower case letter</p>
                        <p> Have at least one number</p>
                        <p> Have at least one of the following:</p>
                        <p> <b>@ # \ - _ $ % ^ &amp; + = § !</b> </p>
                        <p> Spaces are not allowed.</p>
                        <div></div>
                    </div> -->
                </div>


            </mat-card-content>
            <mat-card-content *ngIf="!isShowMsg">
                <form>
                    <div>
                        <h3 class="forMessage">{{ message }}</h3>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center" class="mat-card-actions">
                        <button type="button" [routerLink]="['/login']" mat-button color="primary" matSufix>Go to Home</button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>

</section>